import { caseCategories } from '@/mocks/cases';

interface CasesFilterProps {
  active: string;
  onChange: (key: string) => void;
}

export default function CasesFilter({ active, onChange }: CasesFilterProps) {
  return (
    <div className="sticky top-[72px] z-40 bg-[#fafaf8]/95 backdrop-blur-md border-b border-[#e2ddd8]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-2 overflow-x-auto py-4 scrollbar-none">
          {caseCategories.map((cat) => (
            <button
              key={cat.key}
              onClick={() => onChange(cat.key)}
              className={`whitespace-nowrap px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                active === cat.key
                  ? 'bg-[#b8956a] text-white'
                  : 'bg-[#f4f2ef] text-[#5a5a5a] hover:bg-[#e8e4df]'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
